
const PRODUCTION = 'https://seiproject4.herokuapp.com'
const DEVELOPMENT = 'http://127.0.0.1:8000'

const URL = PRODUCTION

export default URL